import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { Device } from '../api/models';

@Directive({
  selector: '[deviceIcon]',
  standalone: true,
})
export class DeviceIconDirective implements OnInit {
  @Input('deviceIcon') device: Device;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi  mdi-26px ';

    switch (this.device) {
      case Device.Desktop:
        classList += 'mdi-laptop tw-text-blue-500 dark:tw-text-blue-400';
        break;

      case Device.Tablet:
        classList += 'mdi-tablet tw-text-teal-500 dark:tw-text-teal-400';
        break;

      case Device.Mobile:
        classList += 'mdi-cellphone tw-text-orange-500 dark:tw-text-orange-400';
        break;

      case Device.Watch:
        classList += 'mdi-watch tw-text-gray-500 dark:tw-text-gray-400';
        break;

      case Device.Tv:
        classList +=
          'mdi-television-box tw-text-indigo-600 dark:tw-text-indigo-500';
        break;

      case Device.Console:
        classList += 'mdi-console tw-text-red-600 dark:tw-text-red-500';
        break;

      case Device.Car:
        classList += 'mdi-car tw-text-green-600 dark:tw-text-green-500';
        break;

      case Device.IoT:
        classList += 'mdi-network tw-text-purple-600 dark:tw-text-purple-500';
        break;
      case Device.Unknown:
        classList += 'mdi-help-circle-outline tw-text-gray-400 tw-opacity-70 mdi-22px';
        break;

      default:
        classList += 'mdi-device-hub tw-text-gray-600 dark:tw-text-gray-500'; // رنگ پیش‌فرض
        break;
    }

    return classList;
  }
}
